"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addVoucher = addVoucher;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
async function addVoucher({
  client,
  globalShoppingVoucherCodeDto,
  sessionId,
  tenant
}) {
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  return (0, _globalApiClientReact.createShoppingSessionVoucherCode)(client, sessionId, globalShoppingVoucherCodeDto, headers);
}